import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Button, Badge } from 'react-bootstrap';
import { FaFilter, FaEdit } from 'react-icons/fa';

const AsignacionesFiltrosButton = ({ onOpenFilters, activeFiltersCount = 0, onBulkEdit, selectedCount = 0 }) => {
    return (
        <Row className="mb-3">
            <Col xs={12} className="d-flex justify-content-start gap-2">
                <Button 
                    variant="outline-primary" 
                    onClick={onOpenFilters}
                    className="d-flex align-items-center"
                >
                    <FaFilter className="me-2" />
                    Filtros
                    {activeFiltersCount > 0 && (
                        <Badge bg="primary" className="ms-2">
                            {activeFiltersCount}
                        </Badge>
                    )}
                </Button>
                {onBulkEdit && (
                    <Button
                        variant="outline-success"
                        onClick={onBulkEdit}
                        disabled={selectedCount === 0}
                        className="d-flex align-items-center"
                        title={selectedCount === 0 ? "Selecciona asignaciones para editar" : `Editar ${selectedCount} asignaciones`}
                    >
                        <FaEdit className="me-2" />
                        Edición Masiva
                        {selectedCount > 0 && (
                            <Badge bg="success" className="ms-2">
                                {selectedCount}
                            </Badge>
                        )}
                    </Button>
                )}
            </Col>
        </Row>
    );
};

AsignacionesFiltrosButton.propTypes = {
    onOpenFilters: PropTypes.func.isRequired,
    activeFiltersCount: PropTypes.number,
    onBulkEdit: PropTypes.func,
    selectedCount: PropTypes.number
};

export default AsignacionesFiltrosButton;
